export default __webpack_public_path__ + "static/media/architecture-img-11.a4cfc3f8.jpg";